import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';
import { initRawSchema, toParagraphContent } from '@principle-theorem/editor';

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['{brandSlug}/{practiceSlug}/contacts'],
  validationMode: 'any',
};

export const externalContactsStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.ExternalContacts,
  category: PracticeSetupStepCategory.Miscellaneous,
  title: 'Manage Your Contacts',
  description: initRawSchema([
    toParagraphContent(
      `Your Contacts page serves as a comprehensive address book for all professional contacts associated with your practice. This may include specialists, suppliers, catering companies, referrers, and more.`
    ),
    toParagraphContent(
      `If migrating your data from your current PMS, contacts with all required fields will be brought across.`
    ),
  ]),
  dependsOn: [],
  getRoute: (brand, practice) => `${brand.slug}/${practice.slug}/contacts`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed || options?.skipped) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason: 'Please review the contacts before completing this step',
        };
      })
    );
  },
  pageVisitTracking,
};
